import { Link } from "react-router-dom";

const Terms = () => {
  return (
    <div data-testid="terms-page" className="pt-20">
      {/* Hero Section */}
      <section className="py-24 md:py-32 bg-cream">
        <div className="container mx-auto px-4 md:px-8">
          <div className="max-w-3xl">
            <p className="text-xs uppercase tracking-[0.3em] text-taupe mb-4">
              Legal
            </p>
            <h1 className="font-serif text-5xl md:text-6xl font-light tracking-tight leading-[0.9] text-matte">
              Terms of Service
            </h1>
            <p className="mt-6 text-sm text-matte/50">
              Last updated: December 2025
            </p>
          </div>
        </div>
      </section>

      {/* Content */}
      <section className="py-16 md:py-24 bg-smoke">
        <div className="container mx-auto px-4 md:px-8">
          <div className="max-w-3xl mx-auto prose prose-lg">
            <div className="space-y-8">
              <div>
                <h2 className="font-serif text-2xl text-matte mb-4">Agreement to Terms</h2>
                <p className="text-matte/70 font-light leading-relaxed">
                  By accessing or using the services provided by Medical Aesthetic Arts LLC through our website aestheticmedicalarts.online, you agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use our services.
                </p>
              </div>

              <div>
                <h2 className="font-serif text-2xl text-matte mb-4">Services</h2>
                <p className="text-matte/70 font-light leading-relaxed">
                  Medical Aesthetic Arts LLC provides aesthetic medical services including but not limited to facial balancing, injectable treatments, skin rejuvenation, and body contouring. All services are provided by licensed medical professionals in accordance with applicable laws and regulations.
                </p>
              </div>

              <div>
                <h2 className="font-serif text-2xl text-matte mb-4">Appointments and Cancellations</h2>
                <p className="text-matte/70 font-light leading-relaxed mb-4">
                  By scheduling an appointment with Medical Aesthetic Arts LLC, you agree to:
                </p>
                <ul className="list-disc pl-6 text-matte/70 font-light space-y-2">
                  <li>Provide accurate contact and health information</li>
                  <li>Arrive on time for scheduled appointments</li>
                  <li>Provide at least 24 hours notice for cancellations</li>
                  <li>Pay any applicable cancellation fees for late cancellations or no-shows</li>
                </ul>
              </div>

              <div>
                <h2 className="font-serif text-2xl text-matte mb-4">Payment Terms</h2>
                <p className="text-matte/70 font-light leading-relaxed">
                  Payment is due at the time of service unless other arrangements have been made. We accept major credit cards and other payment methods as displayed at our locations. Prices are subject to change without notice.
                </p>
              </div>

              <div>
                <h2 className="font-serif text-2xl text-matte mb-4">Limitation of Liability</h2>
                <p className="text-matte/70 font-light leading-relaxed">
                  Medical Aesthetic Arts LLC shall not be liable for any indirect, incidental, special, consequential, or punitive damages resulting from your use of our services. Our total liability shall not exceed the amount paid for the specific service giving rise to the claim.
                </p>
              </div>

              <div>
                <h2 className="font-serif text-2xl text-matte mb-4">Contact Us</h2>
                <p className="text-matte/70 font-light leading-relaxed">
                  If you have questions about these Terms of Service, please contact us at:
                </p>
                <div className="mt-4 text-matte/70 font-light">
                  <p><strong>Medical Aesthetic Arts LLC</strong></p>
                  <p>Main Office: 3100 Smoketree Ct, Ste 800, Raleigh, NC 27604</p>
                  <p>Headquarters: 1950 Bluegrass Cir, Ste 360, Cheyenne, WY 82001</p>
                  <p>Phone: (844) 943-6191</p>
                  <p>Email: info@aestheticmedicalarts.online</p>
                  <p>Website: aestheticmedicalarts.online</p>
                </div>
              </div>
            </div>

            <div className="mt-12 pt-8 border-t border-matte/10">
              <Link to="/" className="btn-secondary">
                Return to Home
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Terms;
